// import { navigate } from 'hookrouter'
import React, { FC } from 'react'
import { updateProjectStatus } from 'state/async_actions'
import { useAppContext } from 'state/context'
import { TemplateDeletionWarningModal } from 'components/TemplateDeletionWarningModal'
import { ProjectStatusWarningModal } from 'components/ProjectStatusWarningModal'

// import { ListGroup } from 'react-bootstrap'
// import { ProjectRolesParam, userRoles } from 'types'

export const ProjectStatus: FC<any> = ({project}) => {

  const [, dispatch] = useAppContext()
  const [activeStatus, setProjectActiveStatus] = React.useState<(() => () => void) | undefined>();
  const [disableStatus, setProjectDisableStatus] = React.useState<(() => () => void) | undefined>();

  const resetProjectActiveUpdationWarning = () => {
    setProjectActiveStatus(undefined)
  }

  const warnAndUpdateActiveStatus = (type: any) => {
    setProjectActiveStatus(() => () => {
      updateProjectStatus(dispatch, project.id, { project: { status: 1 }, confirm_download: false })
      window.location.reload();
    });
  }
  const warnAndUpdateDisableStatus = (type: any) => {
    setProjectDisableStatus(() => () => {
      updateProjectStatus(dispatch, project.id, { project: { status: 0 }, confirm_download: true })
      window.location.reload();
    });
  }

  const skipDownload = () => {
    updateProjectStatus(dispatch, project.id, { project: { status: 0 }, confirm_download: false })
  }

const warningText = 'Are you sure you want to update Project Status?'

  return (
  <>
  {disableStatus && 
  (
    <ProjectStatusWarningModal
      downloadAction={disableStatus}
      skipAction={skipDownload}
    />
  )}
      {activeStatus && (
        <TemplateDeletionWarningModal
          confirmAction={activeStatus}
          updateParentState={resetProjectActiveUpdationWarning}
          text={warningText}
        />
      )}
    <div style= {{width: '128%'}}>
      <div><h3 style={{ fontSize:'21px' }}>Status</h3></div>
      <div style={{border: 'solid 1px lightgrey', borderRadius: '5px', padding: '10px'}}>
      <div className="radio" style={{ borderBottom: 'solid 1px lightgray'}}>
          <label style={{fontWeight: 'bold'}}>
            <input
              type="radio"
              value="active"
              name="status"
              checked={project?.status === "active"}
              onChange={()=> warnAndUpdateActiveStatus('active')}
            />
            <span style={{paddingLeft:'10px'}}>Active</span>
          </label>
        </div>
        <div className="radio">
          <label style={{fontWeight: 'bold'}}>
            <input
              type="radio"
              value="inactive"
              name="status"
              checked={project?.status === "inactive"}
              onChange={()=> warnAndUpdateDisableStatus('inactive')}
            />
            <span style={{paddingLeft:'10px'}}>Inactive</span>
          </label>
        </div>
     </div>
      <br/>
    </div>
  </>
  )
}